var React = require('react');

function Cast (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V8","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M11 20C11 15.0294 6.97056 11 2 11","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M7 20C7 17.2386 4.76142 15 2 15","stroke":"currentColor","strokeWidth":"2","key":2}),React.createElement("path",{"d":"M4 20C4 18.8954 3.10457 18 2 18V20H4Z","fill":"currentColor","key":3})]);
}

Cast.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Cast;

Cast.default = Cast;
